'use client';

import Description from '@/components/Description';
import type { MaterialWithSoftTag } from '@/features/match-maker/utils/match-maker.types';
import { formatDate } from '@/utils/helpers';

interface CalculationDetailProps {
  tag: MaterialWithSoftTag;
}

export const CalculationDetailCard: React.FC<CalculationDetailProps> = ({
  tag,
}) => {
  return (
    <div className="flex flex-col p-4 gap-4">
      <Description
        title="Soft tag name"
        description={tag.tag_name}
        boldDescription
      />
      <div className="grid grid-cols-3 gap-4">
        <Description
          title="Date of creation"
          description={formatDate(tag.tag_created_at)}
          boldDescription
        />
        <Description title="Status" description="Active" boldDescription />
        {/* <Description
          title="Last update"
          description={formatDate(tag.tag_updated_at)}
          boldDescription
        /> */}
        <Description title="Asset type" description="SIGNAL" boldDescription />
        <Description title="Source" description="DCS" boldDescription />
        <Description
          title="Data type"
          description={tag.type || '-'}
          boldDescription
        />
        <Description
          title="Site"
          description={tag.site_id || '-'}
          boldDescription
        />
        <Description
          title="Area"
          description={tag.area || '-'}
          boldDescription
        />
        <Description
          title="Production unit"
          description={tag.production_unit || '-'}
          boldDescription
        />
        <Description
          title="Signal Type"
          description="Digital"
          boldDescription
        />
        <Description
          title="ID"
          description={tag.id || '-'}
          boldDescription
          className="col-span-3"
        />
      </div>
      <Description
        title="Description"
        description={tag.tag_description || '-'}
      />
    </div>
  );
};
